import React from 'react';
import { useEffect } from 'react';
import DOMPurify from 'dompurify';
import Page from '../components/Page';
import QuestionAnswerBox from '../components/QuestionAnswerBox';
import SpiderChart from '../assets/SpiderChart';
import { css } from '@emotion/css';
import { Localized, useLanguage, useLocalizedString } from '../components/Localized';

/**
 * @brief RenderComponent that renders the detail page of the assessment results
 * @param {Int} props.index the index of the dimension that is to be displayed
 * @param {Object} props.assessmentData contains spider scores and questions texts
 * @param {String} props.overviewTitle contains the title of the second paragraph
 * @param {Array} props.overviewInfo contains and array with the information to display a summary of each assessment dimension
 * @param {Object} props.questionRange defines the start and the end of the question answer array for this dimension
 */
const ResultsDetailPage = (props) => {
    const lang = useLanguage();
    let title = (
        <Localized
            de={'Auswertung: ' + props.assessmentData.data[props.index].catName.de}
            en={'Results: ' + props.assessmentData.data[props.index].catName.en}
        />
    );

    /* Initiate Spider Draw after rest of page has fully loaded */
    let spiderIdentifier = 'graphID' + props.index;

    useEffect(() => {
        let options = {
            data: { categories: props.assessmentData.data },
            element: spiderIdentifier,
            active: props.index,
            language: lang,
        };
        let spider = new SpiderChart(options);
    });

    /* Create question answer list for the selected */
    props.assessmentData.answers.slice(
        props.questionRange.start,
        props.questionRange.start + props.questionRange.length
    );
    const questionAnswerData = props.assessmentData.answers.slice(
        props.questionRange.start,
        props.questionRange.start + props.questionRange.length
    );

    const bestPracticeText = useLocalizedString(props.bestPracticeText);

    const questionAnswerList = questionAnswerData.map((element, index) => {
        let score = props.assessmentData.data[props.index].subcatArray[index].subcatUserScore;
        return (
            <QuestionAnswerBox
                key={index.toString()}
                question={element.question}
                answer={element.answer}
                score={score}
            />
        );
    });

    return (
        <Page>
            <h1>{title}</h1>
            <div
                className={css({
                    width: '100%',
                    display: 'flex',
                })}
            >
                <div
                    className={css({
                        flexShrink: 0,
                        width: '60mm',
                        textAlign: 'center',
                        paddingBottom: '2mm',
                    })}
                    id={spiderIdentifier}
                />
                <div
                    className={css({
                        marginLeft: '3mm',
                        flexGrow: 1,
                    })}
                >
                    <b>
                        <Localized {...props.excellenceModel} />
                    </b>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(bestPracticeText),
                        }}
                    />
                </div>
            </div>
            {questionAnswerList}
        </Page>
    );
};

export default ResultsDetailPage;
